import {withRouter, Link} from 'react-router-dom'
import Cookies from 'js-cookie'
import {AiFillHome} from 'react-icons/ai'
import {BsBriefcaseFill} from 'react-icons/bs'
import {FiLogOut} from 'react-icons/fi'
import './index.css'

const Header = props => {
  const logoutButton = () => {
    const {history} = props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }
  return (
    <nav>
      <div className="header-container">
        <Link to="/">
          <img
            className="header-logo-image"
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
          />
        </Link>
        <div className="home-and-jobs">
          <p className="header-text">
            <Link to="/" className="link-element">
              Home
            </Link>
          </p>
          <p className="header-text">
            <Link className="link-element" to="/jobs">
              Jobs
            </Link>
          </p>
        </div>
        <button type="button" className="logoutButton" onClick={logoutButton}>
          Logout
        </button>
        <ul className="nav-mobile-view">
          <li className="header-list">
            <Link to="/">
              <AiFillHome className="icons" />
            </Link>
          </li>
          <li className="header-list">
            <Link to="/jobs">
              <BsBriefcaseFill className="icons" />
            </Link>
          </li>
          <li className="header-list">
            <button
              type="button"
              className="icon-button"
              onClick={logoutButton}
            >
              <FiLogOut className="icons" />
            </button>
          </li>
        </ul>
      </div>
    </nav>
  )
}
export default withRouter(Header)
